// Sign-in, sign-up, password and 2FA screens: brand panel on the left (wide screens), the form on the right
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { LogoMark } from './brand';
import { LanguageSwitch } from './ui';
import { Icon } from './icons';

export function AuthCard({ title, hint, children, signedIn = false }: { title: string; hint?: string; children: ReactNode; signedIn?: boolean }) {
  const { t } = useTranslation();
  return (
    <div className="auth">
      <aside className="auth-side" aria-hidden="false">
        <div className="auth-logo"><LogoMark /><span>VegaPart</span></div>
        <div className="auth-pitch">
          <h2>{t('auth.side_title')}</h2>
          <ul>
            {(['scan', 'ai', 'compliance', 'dollar'] as const).map((ic, i) => (
              <li key={ic}><span className="auth-ico"><Icon name={ic} size={20} /></span><span>{t('auth.side_' + (i + 1))}</span></li>
            ))}
          </ul>
        </div>
        <p className="auth-foot">{t('auth.side_foot')}</p>
      </aside>
      <main className="auth-main">
        <div className="auth-card">
          <div className="auth-top">
            <div className="auth-logo auth-logo-sm"><LogoMark /><span>VegaPart</span></div>
            <LanguageSwitch signedIn={signedIn} />
          </div>
          <div className="auth-head">
            <h1>{title}</h1>
            {hint && <p>{hint}</p>}
          </div>
          {children}
        </div>
      </main>
    </div>
  );
}
